import { createContext, useEffect } from 'react';
import { register as registerServiceWorker, unregister as unregisterServiceWorker } from '../serviceWorker';

interface ContextInterface {}

interface PropsInterface {
  children: any;
}

const CacheControlContext = createContext<ContextInterface>({});

export function CacheControlProvider(props: PropsInterface) {
  useEffect(() => {
    if (typeof window !== undefined && typeof document !== 'undefined') {
      const latestVersion = document.documentElement.getAttribute('data-build-version');
      const currentVersion = window.localStorage.getItem('data-build-version');

      if (latestVersion !== currentVersion) {
        unregisterServiceWorker();
        window.localStorage.setItem('data-build-version', latestVersion);
        window.location.reload();

        return;
      }
    }

    // registerServiceWorker();
  }, []);

  return (
    <CacheControlContext.Provider value={{}}>
      <>{props.children}</>
    </CacheControlContext.Provider>
  );
}
